// Dog Longevity Page JavaScript - Essential Functions Only

// Make accordion function globally accessible
window.toggleAccordion = function(header) {
  console.log('toggleAccordion called', header);
  const item = header.parentElement;
  const content = item.querySelector('.accordion-content');
  const icon = header.querySelector('.accordion-icon');
  
  // Close all other accordions
  document.querySelectorAll('.accordion-item').forEach(otherItem => {
    if (otherItem !== item) {
      const otherContent = otherItem.querySelector('.accordion-content');
      const otherIcon = otherItem.querySelector('.accordion-icon');
      const otherHeader = otherItem.querySelector('.accordion-header');
      
      otherContent.classList.remove('active');
      otherIcon.classList.remove('active');
      otherHeader.classList.remove('active');
    }
  });
  
  // Toggle current accordion
  content.classList.toggle('active');
  icon.classList.toggle('active');
  header.classList.toggle('active');
}

// Tabs functionality
window.showTab = function(button, tabId) {
  // Remove active class from all buttons and contents
  document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
  
  // Add active class to clicked button and corresponding content
  button.classList.add('active');
  document.getElementById(tabId).classList.add('active');
}

// Enhanced checkbox functionality with progress tracking
window.toggleCheckbox = function(checklistItem) {
  console.log('toggleCheckbox called', checklistItem);
  const checkbox = checklistItem.querySelector('.checkbox');
  const textSpan = checklistItem.querySelector('span');
  
  if (!checkbox) {
    console.error('Checkbox not found in checklist item');
    return;
  }
  
  checkbox.classList.toggle('checked');
  console.log('Checkbox checked state:', checkbox.classList.contains('checked'));
  
  if (checkbox.classList.contains('checked')) {
    // Add celebration effect
    checkbox.style.animation = 'checkboxCelebrate 0.6s ease';
    setTimeout(() => {
      checkbox.style.animation = '';
    }, 600);
    
    // Add strikethrough to text
    textSpan.style.textDecoration = 'line-through';
    textSpan.style.opacity = '0.7';
    
    // Create floating "Great job!" text
    createFloatingText(checkbox, '✨ Great job!');
  } else {
    // Remove strikethrough
    textSpan.style.textDecoration = 'none';
    textSpan.style.opacity = '1';
  }
  
  // Update progress
  console.log('Calling updateProgress...');
  updateProgress();
}

// Update progress bar and counter
function updateProgress() {
  console.log('updateProgress called');
  const totalCheckboxes = document.querySelectorAll('.checklist-item .checkbox').length;
  const checkedCheckboxes = document.querySelectorAll('.checklist-item .checkbox.checked').length;
  const percentage = Math.round((checkedCheckboxes / totalCheckboxes) * 100);
  
  console.log('Progress:', checkedCheckboxes, 'of', totalCheckboxes, '=', percentage + '%');
  
  // Update progress elements
  const progressCountEl = document.getElementById('progress-count');
  const totalCountEl = document.getElementById('total-count');
  const progressPercentEl = document.getElementById('progress-percent');
  const progressFillEl = document.getElementById('progress-fill');
  
  if (progressCountEl) progressCountEl.textContent = checkedCheckboxes;
  if (totalCountEl) totalCountEl.textContent = totalCheckboxes;
  if (progressPercentEl) progressPercentEl.textContent = percentage + '%';
  
  if (progressFillEl) {
    progressFillEl.style.width = percentage + '%';
    console.log('Progress fill width set to:', percentage + '%');
  } else {
    console.error('progress-fill element not found');
  }
  
  // Celebration when all completed
  if (checkedCheckboxes === totalCheckboxes && totalCheckboxes > 0) {
    setTimeout(() => {
      createCelebrationBurst();
      showCompletionModal();
    }, 500);
  }
}

// Create floating text animation
function createFloatingText(element, text) {
  const floatingText = document.createElement('div');
  floatingText.textContent = text;
  floatingText.className = 'floating-text';
  
  const rect = element.getBoundingClientRect();
  
  floatingText.style.position = 'fixed';
  floatingText.style.left = rect.left + (rect.width / 2) + 'px';
  floatingText.style.top = rect.top - 10 + 'px';
  floatingText.style.transform = 'translateX(-50%)';
  floatingText.style.color = '#28a745';
  floatingText.style.fontWeight = 'bold';
  floatingText.style.fontSize = '16px';
  floatingText.style.pointerEvents = 'none';
  floatingText.style.zIndex = '1000';
  floatingText.style.animation = 'floatUp 2s ease-out forwards';
  
  document.body.appendChild(floatingText);
  
  setTimeout(() => {
    floatingText.remove();
  }, 2000);
}

// Create celebration burst effect
function createCelebrationBurst() {
  for (let i = 0; i < 20; i++) {
    const particle = document.createElement('div');
    particle.innerHTML = ['🎉', '✨', '🐾', '❤️'][Math.floor(Math.random() * 4)];
    particle.className = 'celebration-particle';
    
    particle.style.position = 'fixed';
    particle.style.left = '50%';
    particle.style.top = '50%';
    particle.style.fontSize = Math.random() * 20 + 15 + 'px';
    particle.style.pointerEvents = 'none';
    particle.style.zIndex = '1001';
    particle.style.animation = `burstOut 1.5s ease-out forwards`;
    particle.style.setProperty('--random-x', (Math.random() - 0.5) * 400 + 'px');
    particle.style.setProperty('--random-y', (Math.random() - 0.5) * 400 + 'px');
    
    document.body.appendChild(particle);
    
    setTimeout(() => {
      particle.remove();
    }, 1500);
  }
}

// Show completion modal
function showCompletionModal() {
  const modal = document.createElement('div');
  modal.className = 'completion-modal';
  modal.innerHTML = `
    <div class="modal-content">
      <h3>🎉 Amazing Work!</h3>
      <p>You've completed all the high-impact actions for your dog's longevity!</p>
      <p>Your pup is lucky to have such a caring parent. Keep up the great work!</p>
      <button onclick="this.parentElement.parentElement.remove()" class="modal-close">Continue Reading</button>
    </div>
  `;
  
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.width = '100%';
  modal.style.height = '100%';
  modal.style.backgroundColor = 'rgba(0,0,0,0.8)';
  modal.style.display = 'flex';
  modal.style.alignItems = 'center';
  modal.style.justifyContent = 'center';
  modal.style.zIndex = '1002';
  modal.style.animation = 'fadeIn 0.3s ease';
  
  document.body.appendChild(modal);
}

// Body Condition Score functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing Body Condition Score...');
  
  // Initialize progress bar
  updateProgress();
  const scoreNumbers = document.querySelectorAll('.score-number');
  const descriptionArea = document.getElementById('score-description');
  
  console.log('Found score numbers:', scoreNumbers.length);
  console.log('Found description area:', descriptionArea);
  
  // Body Condition Score descriptions
  const scoreDescriptions = {
    '1': 'Emaciated: Ribs, spine, and hip bones are easily visible from a distance. No body fat.',
    '2': 'Very Thin: Ribs, spine, and hip bones are easily felt and visible. Minimal body fat.',
    '3': 'Thin: Ribs are easily felt with minimal fat covering. Waist is easily visible from above.',
    '4': 'Ideal: Ribs are easily felt with a slight fat cover. Visible waist from above.',
    '5': 'Ideal: Ribs are easily felt without excess fat. Waist is visible from above.',
    '6': 'Overweight: Ribs are felt with difficulty under a heavy fat cover. Waist is barely visible.',
    '7': 'Heavy: Ribs are very difficult to feel under a thick fat cover. No waist visible.',
    '8': 'Obese: Ribs cannot be felt under a very thick fat cover. No waist. Fat deposits on neck and limbs.',
    '9': 'Morbidly Obese: Massive fat deposits on chest, spine, and base of tail. No waist or abdominal tuck.'
  };
  
  if (descriptionArea && scoreNumbers.length > 0) {
    scoreNumbers.forEach(scoreNumber => {
      // Click functionality
      scoreNumber.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const score = this.getAttribute('data-score');
        console.log('Clicked score:', score);
        
        // Remove active class from all numbers
        scoreNumbers.forEach(num => num.classList.remove('active'));
        
        // Add active class to clicked number
        this.classList.add('active');
        
        // Show description below
        descriptionArea.innerHTML = `<p><strong>Score ${score}:</strong> ${scoreDescriptions[score]}</p>`;
        
        // Add a subtle animation
        descriptionArea.style.animation = 'fadeIn 0.3s ease';
      });
    });
  } else {
    console.error('Body Condition Score elements not found:', {
      scoreNumbers: scoreNumbers.length,
      descriptionArea: !!descriptionArea
    });
  }

  // Scroll reveal animations
  const revealElements = document.querySelectorAll('[data-reveal]');
  
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  revealElements.forEach(element => {
    element.classList.add('reveal-hidden');
    revealObserver.observe(element);
  });

  // Image parallax effect on scroll
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const heroImage = document.querySelector('.hero-dog-image');
    if (heroImage) {
      heroImage.style.transform = `translateY(${scrolled * 0.1}px)`;
    }

    // Floating paws movement
    const paws = document.querySelectorAll('.floating-paw');
    paws.forEach((paw, index) => {
      const speed = (index + 1) * 0.05;
      paw.style.transform = `translateY(${Math.sin(scrolled * speed) * 20}px)`;
    });
  });

  // Enhanced visual feedback and micro-interactions
  document.querySelectorAll('.intro-image-card, .accordion-item').forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.filter = 'brightness(1.05)';
      card.style.transform = 'translateY(-2px) scale(1.02)';
    });
    
    card.addEventListener('mouseleave', () => {
      card.style.filter = 'brightness(1)';
      card.style.transform = '';
    });
  });

  // Add click feedback to all buttons
  document.querySelectorAll('button, .btn-primary, .tab-button').forEach(element => {
    element.addEventListener('click', (e) => {
      // Visual "click" feedback
      element.style.transform = 'scale(0.95)';
      setTimeout(() => {
        element.style.transform = '';
      }, 150);
    });
  });

  // Initialize floating action button
  initFloatingActionButton();
});

// Floating Action Button functionality
function initFloatingActionButton() {
  const fab = document.getElementById('fab');
  const fabMenu = document.getElementById('fab-menu');
  let isMenuOpen = false;

  if (!fab || !fabMenu) return;

  // Toggle FAB menu
  fab.addEventListener('click', (e) => {
    e.stopPropagation();
    isMenuOpen = !isMenuOpen;
    
    if (isMenuOpen) {
      fabMenu.classList.add('active');
      fab.classList.add('active');
    } else {
      fabMenu.classList.remove('active');
      fab.classList.remove('active');
    }
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (isMenuOpen && !fab.contains(e.target)) {
      fabMenu.classList.remove('active');
      fab.classList.remove('active');
      isMenuOpen = false;
    }
  });

  // Hide/show FAB based on scroll position
  let lastScrollY = 0;
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    
    if (currentScrollY < 200) {
      fab.style.opacity = '0';
      fab.style.pointerEvents = 'none';
    } else {
      fab.style.opacity = '1';
      fab.style.pointerEvents = 'all';
      
      if (currentScrollY > lastScrollY + 5) {
        fab.style.transform = 'translateY(100px) scale(0.8)';
      } else if (currentScrollY < lastScrollY - 5) {
        fab.style.transform = 'translateY(0) scale(1)';
      }
    }
    
    lastScrollY = currentScrollY;
  });
}

// Smooth scroll to section
function scrollToSection(selector) {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    
    // Close FAB menu
    const fabMenu = document.getElementById('fab-menu');
    const fab = document.getElementById('fab');
    if (fabMenu && fab) {
      fabMenu.classList.remove('active');
      fab.classList.remove('active');
    }
  }
}

// Show random quick tip
function showQuickTip() {
  const tips = [
    { title: '🐕 Body Weight Tip', text: 'Feel your dog\'s ribs - they should be easily felt but not visible. This is the ideal weight!' },
    { title: '🏃‍♂️ Exercise Tip', text: 'A daily 30-minute walk beats sporadic weekend adventures. Consistency is key!' },
    { title: '🥩 Protein Tip', text: 'High-quality protein becomes even more important as dogs age. Focus on digestibility!' },
    { title: '🐟 Omega-3 Tip', text: 'Fish oil in food is better than expensive supplements. Look for salmon oil in ingredients!' },
    { title: '💡 Portion Tip', text: 'Many dog food bags overestimate portions. Start with less and adjust based on your dog\'s body condition.' }
  ];

  const randomTip = tips[Math.floor(Math.random() * tips.length)];
  
  const tipModal = document.createElement('div');
  tipModal.className = 'tip-modal';
  tipModal.innerHTML = `
    <div class="tip-content">
      <h4>${randomTip.title}</h4>
      <p>${randomTip.text}</p>
      <button onclick="this.parentElement.parentElement.remove()" class="tip-close">Got it! 🐾</button>
    </div>
  `;
  
  tipModal.style.position = 'fixed';
  tipModal.style.top = '0';
  tipModal.style.left = '0';
  tipModal.style.width = '100%';
  tipModal.style.height = '100%';
  tipModal.style.backgroundColor = 'rgba(0,0,0,0.7)';
  tipModal.style.display = 'flex';
  tipModal.style.alignItems = 'center';
  tipModal.style.justifyContent = 'center';
  tipModal.style.zIndex = '1003';
  tipModal.style.animation = 'fadeIn 0.3s ease';
  
  document.body.appendChild(tipModal);
  
  // Close FAB menu
  const fabMenu = document.getElementById('fab-menu');
  const fab = document.getElementById('fab');
  if (fabMenu && fab) {
    fabMenu.classList.remove('active');
    fab.classList.remove('active');
  }
}